import React from 'react';
import { Field } from 'react-final-form';

// Hooks
import { useTranslation } from 'Shared/utils/hooks/use-translation';

// Utils
import { required } from 'Shared/utils/formValidations';

// Components
import FieldGroup from 'Shared/components/FormComponents/FieldGroup/FieldGroup';
import FieldMetricType from './FieldMetricType';

// Styles
import './GoalTracking.scss';

type Props = {
  isEdit?: boolean;
};

const GoalTracking = ({ isEdit }: Props) => {
  const { tr } = useTranslation();
  const baseClassName = 'GoalTracking';

  return (
    <div className={baseClassName}>
      <FieldGroup
        label={tr('perform.goals.tracking.measure_progress_label')}
        labelClassName={`${baseClassName}__label`}
        required
        labelRequired={tr('perform.goals.form.required_indicator')}
      >
        <Field name="metricType" component={FieldMetricType} validate={required} isEdit={isEdit} />
      </FieldGroup>
    </div>
  );
};

export default GoalTracking;
